export default __webpack_public_path__ + "static/media/logo.68164987.svg";